import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from "@material-ui/core/Fade";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Link } from "react-router-dom";
import { logoutUser, getProfile } from "../../services/api/apiHandler";

import { ReactComponent as MyFinIcon } from "../assets/icons/myfin.svg";
import { ReactComponent as HomeIcon } from "../assets/icons/home.svg";
import { ReactComponent as CompanyIcon } from "../assets/icons/company.svg";
import { ReactComponent as LibraryIcon } from "../assets/icons/library.svg";
import { ReactComponent as SettingsIcon } from "../assets/icons/settings.svg";
import { ReactComponent as ConnectorIcon } from "../assets/icons/connector.svg";
import { ReactComponent as LogsIcon } from "../assets/icons/logs.svg";
import { ReactComponent as AdminportalIcon } from "../assets/icons/adminportal.svg";
import { ReactComponent as NotificationIcon } from "../assets/icons/notification.svg";
import defaultUserImg from "../../assets/Image/defaultUserImage.png";
import "../css/sidebar.css";
import { Tooltip2 } from "../elements/Tooltip";

export default function Sidebar() {
	const history = useHistory();

	const [anchorEl, setAnchorEl] = React.useState(null);
	const [profileImg, setProfileImg] = useState(defaultUserImg);
	const open = Boolean(anchorEl);
	const [showAdmin, setShowAdmin] = useState(false)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	function handlelprofile() {
		history.push("/profile-change");
		setAnchorEl(null);
	}

	function handlelogout() {
		logoutUser()
			.then((response) => {
				// toast.success("Logout Successfully");
				localStorage.removeItem("auth_token");
				history.push("/");
				setAnchorEl(null);
			})
			.catch((error) => {
				toast.error(error.response?.data?.error || "Logout Failed!");
			});
	}

	useEffect(() => {
		async function fetchUser() {
			try {
				const res = await getProfile();

				const userData = res.data.user.data
				console.log(userData, 'userData');
				
				const url = userData?.profile_image?.url;

				if(userData?.isAdmin === "Yes"  
					// && userData.has_subscribed !== "free"
				){
					setShowAdmin(true)
				}

				if (url) {
					setProfileImg(url);
				} else {
					setProfileImg(defaultUserImg);
				}
			} catch (err) {
				setProfileImg(defaultUserImg);
				console.log("Error");

			}
		}
		fetchUser();
	}, []);

	return (
		<aside className="sidebar">
			<div className="sidebar-top">
				<Link to="/dashboard">
					<MyFinIcon width={32} height={26} />
				</Link>
			</div>

			<div className="sidebar-middle">
				<Tooltip2 content={"Home"} variant="black" position="right_2">
					<Link to="/dashboard">
						<HomeIcon height={22} width={22} className="clickable-icon" />
					</Link>
				</Tooltip2>

				<Tooltip2 content={"Companies"} variant="black" position="right_2">
					<Link to="/myfinv2/my-companies">
						<CompanyIcon height={22} width={22} className="clickable-icon" />
					</Link>
				</Tooltip2>

				<Tooltip2 content={"Libraries"} variant="black" position="right_2">
					<Link to="/myfinv2/library/standalone-library">
						<LibraryIcon height={22} width={22} className="clickable-icon" />
					</Link>
				</Tooltip2>

				<Tooltip2 content={"Settings"} variant="black" position="right_2">
					<Link to="/myfinv2/">
						<SettingsIcon height={22} width={22} className="clickable-icon" />
					</Link>
				</Tooltip2>

				<Tooltip2 content={"ERP Connectors"} variant="black" position="right_2">
					<Link to="/myfinv2/connections">
						<ConnectorIcon height={22} width={22} className="clickable-icon" />
					</Link>
				</Tooltip2>
				{showAdmin && (
					<Tooltip2 content={"Audit Logs"} variant="black" position="right_2">
						<Link to="/logs">
						<LogsIcon height={22} width={22} className="clickable-icon" />
						</Link>
					</Tooltip2>
				)}
				{showAdmin && (
					<Tooltip2 content={"Admin Portal"} variant="black" position="right_2">
						<Link to="/admin">
						<AdminportalIcon height={22} width={22} className="clickable-icon" />
						</Link>
					</Tooltip2>
				)}
			</div>

			<div className="sidebar-bottom">
					<Tooltip2 content={"Notifications"} variant="black" position="right_2">
						<Link to="/notification">
							<NotificationIcon
								height={22}
								width={22}
								className="clickable-icon"
							/>
						</Link>
					</Tooltip2>
				<div
					onClick={handleClick}
					size="large"
					// sx={{ ml: 2 }}
					aria-controls={open ? "account-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
				>
					<img
						className="user-img clickable-icon"
						src={profileImg}
						alt="user_image"
						onError={(e) => {
							e.currentTarget.src = defaultUserImg;
						}}
					/>
				</div>
				<Menu
					id="fade-menu"
					MenuListProps={{
						"aria-labelledby": "fade-button",
					}}
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					TransitionComponent={Fade}
					transformOrigin={{ horizontal: "right", vertical: "top" }}
				>
					<MenuItem onClick={handlelprofile} className="font-sans ">
						Profile
					</MenuItem>
					<MenuItem onClick={handlelogout} className="font-sans ">
						Logout
					</MenuItem>
				</Menu>
			</div>
		</aside>
	);
}
